import { GridView } from '@vivli/shared/views';
import { GridApi } from 'ag-grid-community';
import { IDataRequestSummary } from '@vivli/features/data-requests/infrastructure/interface';
import { DATA_REQUEST_ROW_HEIGHT, dataRequestGridCustomComponents, useDataRequestGridColumns } from './data-requests-grid-columns.hook';

interface DataRequestsGridComponentProps {
    dataRequests: IDataRequestSummary[];
    onRowClick?: (dataRequest: IDataRequestSummary) => void;
    onGridReady?: (gridApi: GridApi) => void;
    emptyMessage?: string;
    autoHeight?: boolean;
    isPresumedResearcher?: boolean; //we don't have myrequests page type any more, lets us set certain properties
    // originally tied to page type
    onRowCountChange?: (count: number) => void;
    initialSortField?: string;
    initialSortOrder?: 'asc' | 'desc';
}

// The client-side Data Requests grid (the AMR My Data Requests page). DEV-958: a table with a
// visible header and floating filters; ag-grid sorts and filters the loaded rows itself.
export const DataRequestsGridComponent = ({
    dataRequests,
    onRowClick,
    onGridReady,
    emptyMessage,
    autoHeight,
    onRowCountChange,
    isPresumedResearcher,
    initialSortField,
    initialSortOrder
}: DataRequestsGridComponentProps) => {
    const handleRowClick = (dataRequest: IDataRequestSummary) => {
        onRowClick && onRowClick(dataRequest);
    };

    const columns = useDataRequestGridColumns({ isPresumedResearcher, initialSortField, initialSortOrder });

    return (
        <GridView
            rowData={dataRequests}
            columns={columns}
            fullWidthColumns={true}
            customComponents={dataRequestGridCustomComponents}
            rowHeight={DATA_REQUEST_ROW_HEIGHT}
            onRowClick={handleRowClick}
            onGridReady={onGridReady}
            emptyMessage={emptyMessage}
            autoHeight={autoHeight}
            onRowCountChange={onRowCountChange}
        />
    );
};
